// External Components
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
// import 'material-icons'
import VueLocalStorage from 'vue-localstorage'

// Internal Components'
import '@/components'
import store from '@/store'
import router from '@/router'

// Initialize Firebase
import { debug, auth } from '@/utils/firebase'
console.log('Debug is:',debug)

// Utilities
import { pad, unmaskPhone } from '@/utils/general'
global.pad = pad
global.unmaskPhone = unmaskPhone

// Sync router with store
import { sync } from 'vuex-router-sync'
// import Vuetify from 'vuetify';

// const vuetify = new Vuetify({
//   theme: themes[0]
// })

// Local Storage using Vue
// https://github.com/pinguinjkeke/vue-local-storage
Vue.use(VueLocalStorage, {
  name: 'localStorage',
  // bind: true //created computed members from your variable declarations
})
// 'genericLoaderPosition' : tracks where in loader message sequence customer left off (limit repeating phrases)

// Sync store with router
sync(store, router)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  vuetify: vuetify,
  created: () => {
    // debug or not
    store.commit('SET_DEBUG', debug == 'false' ? false : true)

    //Set up product listener
    store.dispatch('listenerAllProducts')
    
    auth.onAuthStateChanged(async (user) => {
      store.commit('SET_LOADING')
      store.dispatch('userSignIn', user)
      if(user) {
        store.commit('SET_MENU_CONTROL', true)
      }
      store.commit('CLEAR_LOADING')
    })
  },
  render: h => h(App)
}).$mount('#app')
